import VueSticky from 'vue-sticky'

const AppDirectives = {
    install(Vue) {
        Vue.directive('sticky', VueSticky)
    }
}

export default AppDirectives
